const removeVietnameseTones = (str) => {
  return str.normalize('NFC')
    .replace(/[àảãáạăằẳẵắặâầẩẫấậ]/g, "a")
    .replace(/[ÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ]/g, "A")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .replace(/[èẻẽéẹêềểễếệ]/g, "e")
    .replace(/[ÈẺẼÉẸÊỀỂỄẾỆ]/g, "E")
    .replace(/[ìỉĩíị]/g, "i")
    .replace(/[ÌỈĨÍỊ]/g, "I")
    .replace(/[òỏõóọôồổỗốộơờởỡớợ]/g, "o")
    .replace(/[ÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ]/g, "O")
    .replace(/[ùủũúụưừửữứự]/g, "u")
    .replace(/[ÙỦŨÚỤƯỪỬỮỨỰ]/g, "U")
    .replace(/[ỳỷỹýỵ]/g, "y")
    .replace(/[ỲỶỸÝỴ]/g, "Y")
    .replace(/\+/g, '')
    .replace(/\./g, '')
    .replace(/\\/g, '')
    .replace(/\*/g, "")
    .toLowerCase()
    .trim();
};

const removeVietnameseTones2 = (str) => {
  return str.normalize('NFC')
    .replace(/[àảãáạăằẳẵắặâầẩẫấậ]/g, "a")
    .replace(/[ÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ]/g, "A")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .replace(/[èẻẽéẹêềểễếệ]/g, "e")
    .replace(/[ÈẺẼÉẸÊỀỂỄẾỆ]/g, "E")
    .replace(/[ìỉĩíị]/g, "i")
    .replace(/[ÌỈĨÍỊ]/g, "I")
    .replace(/[òỏõóọôồổỗốộơờởỡớợ]/g, "o")
    .replace(/[ÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ]/g, "O")
    .replace(/[ùủũúụưừửữứự]/g, "u")
    .replace(/[ÙỦŨÚỤƯỪỬỮỨỰ]/g, "U")
    .replace(/[ỳỷỹýỵ]/g, "y")
    .replace(/[ỲỶỸÝỴ]/g, "Y")
    .trim();
};

const findFirstIndexInString = (A, B) => {
  const isAlphaNumeric = (char) => /[a-zA-Z0-9]/.test(char);

  for (let i = 0; i <= A.length - B.length; i++) {
      if (A.slice(i, i + B.length) === B) {
          const before = i > 0 ? A[i - 1] : '';
          const after = i + B.length < A.length ? A[i + B.length] : '';

          if (!isAlphaNumeric(before) && !isAlphaNumeric(after)) {
              return i;
          }
      }
    }
  return null
}

const getFileExtension = (filename) => {
  filename = filename.trim()
  return filename.split('.').pop();
}

const isDigit = (char) => {
  return char >= '0' && char <= '9';
}

const groupByName = (arr, fieldName1, fieldName2) => {
  const groups = {};
  const numberGroup = [];
  arr.forEach(item => {
    const firstLetter = (item[fieldName1] ? item[fieldName1].charAt(0) : item[fieldName2].charAt(0)).toLowerCase();
    if (isDigit(firstLetter)) {
      numberGroup.push(item);
    } else {
      if (!groups[firstLetter]) {
        groups[firstLetter] = [];
      }
      groups[firstLetter].push(item);
    }
  });

  const result = Object.values(groups);
  if (numberGroup.length > 0) {
    result.unshift(numberGroup);
  }

  return result;
}

function generateRandomString(length) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export { removeVietnameseTones,removeVietnameseTones2, getFileExtension, groupByName, generateRandomString, findFirstIndexInString }